"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var disaggregation_type_enum_1 = require("./disaggregation-type.enum");
/**
 * @author gevorg.avetisyan on 2/10/2017.
 */
var IndicatorMeta = /** @class */ (function () {
    function IndicatorMeta(id, guid, name, description, targetFrequencyId, actualFrequencyId, indicatorDisaggregationType, disaggregationGroups, actualDataPoints, targetDataPoints, baselineDataPoints, directionOfChange, dataFormat, startDate, endDate, indicatorRepresentId, otherFields, frameworks, indicatorContextId, roundingUp, dataPointGroupId, aggregationFunction, indicatorTypeId, aggregationRules) {
        this.indicatorStatusId = 1;
        this.id = id;
        this.guid = guid;
        this.name = name;
        this.description = description;
        this.targetFrequencyId = targetFrequencyId;
        this.actualFrequencyId = actualFrequencyId;
        this.indicatorDisaggregationType = indicatorDisaggregationType;
        this.disaggregationGroups = disaggregationGroups;
        this.actualDataPoints = actualDataPoints;
        this.targetDataPoints = targetDataPoints;
        this.baselineDataPoints = baselineDataPoints;
        this.directionOfChange = directionOfChange;
        this.dataFormat = dataFormat;
        if (startDate) {
            var stDate = new Date(startDate);
            this.startDate = new Date(Date.UTC(stDate.getFullYear(), stDate.getMonth(), stDate.getDate()));
        }
        if (endDate) {
            var enDate = new Date(endDate);
            this.endDate = new Date(Date.UTC(enDate.getFullYear(), enDate.getMonth(), enDate.getDate()));
        }
        this.indicatorRepresentId = indicatorRepresentId;
        this.otherFields = otherFields;
        this.frameworks = frameworks;
        this.indicatorContextId = indicatorContextId;
        this.roundingUp = roundingUp;
        this.dataPointGroupId = dataPointGroupId;
        this.aggregationFunction = aggregationFunction;
        this.indicatorTypeId = indicatorTypeId;
        this.aggregationRules = aggregationRules;
    }
    IndicatorMeta.prototype.isDelayered = function () {
        return this.indicatorDisaggregationType === disaggregation_type_enum_1.DisaggregationType.DELAYERED;
    };
    IndicatorMeta.prototype.isLayered = function () {
        return this.indicatorDisaggregationType === disaggregation_type_enum_1.DisaggregationType.LAYERED;
    };
    IndicatorMeta.prototype.getName = function () {
        return this.name.getValue(3);
    };
    IndicatorMeta.prototype.isQualitative = function () {
        return this.indicatorContextId === 3; // 3 is Id of Qualitative Context Type
    };
    return IndicatorMeta;
}());
exports.IndicatorMeta = IndicatorMeta;
//# sourceMappingURL=indicator-meta.model.js.map